import * as React from 'react';
import Reveal from '../Reveal/Reveal';
import Steps, {Step, StepProps} from '../Steps';
import {WizardProps} from './types';

export default class Wizard extends React.Component<WizardProps, {}> {
  // TODO: horizontal mode
  public render() {
    return this._renderVerticalSteps();
  }

  private _renderVerticalSteps() {
    const children = React.Children.map(this.props.children, (child, index) => {
      if (React.isValidElement(child) && child.type === Step) {
        return React.cloneElement(child, {
          children: <Reveal visible={this._isCurrentStep(index)}>{(child.props as StepProps).children}</Reveal>
        } as StepProps);
      }
      return null;
    });

    return (
      <div>
        <Steps {...this.props}>{children}</Steps>
      </div>
    );
  }

  private _isCurrentStep = (index: number) => this.props.currentStepIndex === index;
}



// WEBPACK FOOTER //
// ./src/components/Wizard/Wizard.tsx